import releaseIcons from "data/release-product-icons.json";
import brandIcons from "data/gdn-logo-icons.json";
import logoSources from "data/gdn-logo-sources.json";
import {getProduct} from "data/products/index";

const RELEASE_ICONS = releaseIcons as Record<string, string>;
const BRAND_ICONS = brandIcons as Record<string, string>;
const JETBRAINS_ICON = (logoSources as Record<string, string>)["JETBRAINS_icon.svg"];
if (!JETBRAINS_ICON) throw new Error("gdn-logo-sources.json has no JETBRAINS_icon.svg");

/**
 * The colour icon of a product: the compact mark without the product name.
 * The release demo videos show it (pages/Releases/DemoVideo).
 *
 * In order: the 2026.3 icon of the Figma design
 * (scripts/upload-release-product-icons.ts), the icon of the brand CDN, and
 * for a JetBrains-branded product without an icon of its own (logo family
 * "jb": dotUltimate, Remote Development, …) the JetBrains icon. Any other
 * product without an icon is an error: do not show another product's mark.
 */
export function productIconUrl(productCode: string): string {
  const icon = RELEASE_ICONS[productCode] ?? BRAND_ICONS[productCode];
  if (icon) return icon;
  if ((getProduct(productCode) as {logoFamily?: string} | undefined)?.logoFamily === "jb") {
    return JETBRAINS_ICON;
  }
  throw new Error(
    `No product icon for ${productCode}: add it to data/release-product-icons.json or data/gdn-logo-icons.json`
  );
}
